var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimerSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_482_5799)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4721 33.8195C14.4007 35.8761 17.9344 36.8915 21.5081 36.7033C25.0818 36.5152 28.4893 35.1344 31.1859 32.7817C33.8824 30.429 35.7124 27.2402 36.3833 23.725C37.0542 20.2098 36.5273 16.5711 34.8867 13.3906C33.2461 10.2102 30.5867 7.67149 27.3335 6.18043C24.0802 4.68936 20.421 4.33198 16.9408 5.16541C13.4605 5.99884 10.3601 7.97497 8.13518 10.7779C5.91025 13.5809 4.68923 17.0488 4.66729 20.6274",
    stroke: "#051B46",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.6671 20.7258L4.6671 31.3925M4.6671 31.3925L8.22266 27.5137M4.6671 31.3925L1.11154 27.5137",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.2833 27.836L20.667 24.3575L20.667 13.3575",
    stroke: "#051B46",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_482_5799"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(40.667 0.558472) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerSvg);
export default __webpack_public_path__ + "static/media/timerSvg.ed0ac8298846958eb447823d29ec3945.svg";
export { ForwardRef as ReactComponent };